import Loading from "../../uiStatus/components/Loading";
import { pageShell } from "../../../styles/pageShell";
import { aiChatShell } from "../../../styles/aiChatShell";
import { typeShell } from "../../../styles/typeShell";

/**
 * AI設定の状態表示コンポーネント
 */
export default function AIConfigStatus({ checkingAiConfig, aiConfigError }) {
    if (checkingAiConfig) {
        return (
            <div className={pageShell.container}>
                <div className={pageShell.header}>
                    <h2 className={pageShell.title}>Hummingloom</h2>
                </div>
                <div className={pageShell.card}>
                    <Loading isLoading message="AI設定を確認中..." />
                </div>
            </div>
        );
    }

    if (aiConfigError) {
        return (
            <div className={pageShell.container}>
                <div className={pageShell.header}>
                    <h2 className={pageShell.title}>Hummingloom</h2>
                </div>
                <div className={pageShell.card}>
                    <div className={aiChatShell.messages}>
                        <div className={`${aiChatShell.msgAi} ${aiChatShell.msgCentered}`}>
                            <div className={`${aiChatShell.msgContent} p-8`}>
                                <div className="mb-4">
                                    <span className="material-icons text-icon-empty text-warning">warning</span>
                                </div>
                                <h3 className={`${pageShell.sectionTitle} mb-4 justify-center font-bold`}>
                                    AI機能が利用できません
                                </h3>
                                <p className={`font-normal leading-relaxed ${typeShell.muted}`}>
                                    {aiConfigError.message}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
}
